import signedFetch from '../util/signedFetch.js';

export default (orgId, body) =>
  signedFetch('addOrgLicence', `${__API_BASE__}/org/${encodeURIComponent(orgId)}/licence`, 'POST', body);
